import React from 'react';
import { Formik, Form, Field,  } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as dataSeed from '../../shared/DataSeed';
import * as Yup from "yup";
import { Persist } from 'formik-persist';
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert,
    Fade, FormFeedback
} from 'reactstrap';

export let defaultValue = {
    nik: '',
    fullname: '',
    dob: '',
    pob: '',
    gender: '',
    mobilePhone: '',
    email: '',
    mothersName: '',
    code: ''
}
const valAlphaOnly = /^[a-zA-Z .,]+$/;
const valAlphaNumeric = /^[a-zA-Z 1234567890]+$/;
const valAlphaNumericSpecial = /^[a-zA-Z 1234567890.,'-]+$/;
const nonFirstZero = /^[1-9].*/;
const numericOnly = /^[0-9]*$/;
const dobMax = '2010-01-01';

// const camelcaseKeys = require('camelcase-keys');

const lowerCaseKeys = (obj) => {
    if (typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(lowerCaseKeys);
    }
    if (obj === null) {
        return null;
    }
    const entries = Object.entries(obj);
    const mappedEntries = entries.map(
        ([k, v]) => [
            `${k.substr(0, 1).toLowerCase()}${k.substr(1)}`,
            lowerCaseKeys(v)]
    );
    return Object.fromEntries(mappedEntries);
};

class VerifikasiDataPribadi extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imageHash: '',//Date.now(),
            daftar: localStorage.getItem('dukcapil.daftar') || false,
            valid: false,
            openMessage: false,
            errorMessage: '',
            dataRegister: null
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.pendaftaranClick = this.pendaftaranClick.bind(this);
        this.reloadCaptcha = this.reloadCaptcha.bind(this);
        this.closeErrorMessage = this.closeErrorMessage.bind(this);
    }

    async onSubmit(values, { setFieldValue, setErrors, setStatus, setFieldTouched }) {
        
        try {

            const url = `/api/pengkinianData/verifikasi`;
            const res = await fetch(url, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(values)
            });

            let data;
            const text = await res.text();
            try {
                data = text ? JSON.parse(text) : {};
            } catch (e) {
                data = { ResponseCode: '99', Message: text || 'Terjadi kesalahan sistem' };
            }

            if (res.ok && data.ResponseCode === '00') {
                this.setState({ valid: true, openMessage: true, dataRegister: data.Data, errorMessage: '' });
            } else {
                const errors = data.errors || data.Errors;
                if (errors){
                    setErrors(lowerCaseKeys(errors));
                } else {
                    this.setState({ errorMessage: data.Message || data.message || data.title || (typeof data === 'string' ? data : 'Terjadi kesalahan validasi data') });
                }
                this.setState({ imageHash: Date.now(), dataRegister: { ...this.state.dataRegister, code: '' } });
                setFieldValue('code', '', false);
            }
           
        } catch (err) {
            console.log(err);
            this.setState({ errorMessage: 'Gagal terhubung ke server. Silakan coba beberapa saat lagi.' });
        }

    }

    closeErrorMessage = () => {
        this.setState({errorMessage: ''});
    };

    reloadCaptcha = () => {
        this.setState(({ imageHash: Date.now() }));
    };

    pendaftaranClick() {
        // // eslint-disable-next-line no-restricted-globals
        // let result = confirm("Dengan ini, saya menyatakan bahwa seluruh data yang sudah dan yang akan saya isi dalam pembukaan rekening secara elektronik ini adalah benar adanya dan dengan penuh tanggung jawab yang kemudian dapat dikelola oleh PT Yakin Bertumbuh Sekuritas");
        // if (result === true) {
            this.props.nowRegister(this.state.dataRegister);
            this.setState({ daftar: true, openMessage: false });
            localStorage.setItem('dukcapil.daftar', true);
        // }
    }

    ValidationSchema = Yup.object().shape({
        nik: Yup.string().required('NIK harus diisi').matches(numericOnly, 'Hanya dapat diisi dengan angka').matches(nonFirstZero, 'Angka pertama tidak boleh 0').min(16, 'NIK harus 16 karakter').max(16, 'NIK harus 16 karakter'), //.min(1000000000000000, 'NIK harus 16 digit').max(9999999999999999, 'NIK harus 16 digit'),
        fullname: Yup.string().required('Nama Lengkap harus diisi').matches(valAlphaOnly, 'Nama Lengkap hanya boleh huruf').min(3, 'Nama Lengkap minimal 3 huruf'),
        pob: Yup.string().required('Tempat Lahir harus diisi').matches(valAlphaNumericSpecial, 'Tempat Lahir hanya boleh angka dan huruf').min(3, 'Tempat Lahir minimal 3 huruf'),
        dob: Yup.date().required('Tgl Lahir harus diisi').max(new Date(dobMax), 'Pilih tanggal yang lebih kecil'),
        // code: Yup.string().required('Harus diisi').min(4, 'Minimal 4 huruf').matches(valAlphaNumeric, 'Hanya angka dan huruf'),
        gender: Yup.string().required('Jenis Kelamin harus dipilih'),
        email: Yup.string().required('Email harus diisi').email('Format email tidak valid'),
        mothersName: Yup.string().required('Nama Ibu Kandung harus diisi').matches(valAlphaOnly, 'Nama Ibu Kandung hanya boleh huruf')
    });

    render() {
        const imageValidation = "/api/register/image-validation";
        return (<React.Fragment>
            <UncontrolledAlert color="success" isOpen={this.state.openMessage}>Data berhasil di verfikasi, lanjutkan ke pengkinian data.</UncontrolledAlert>
            <UncontrolledAlert toggle={() => this.closeErrorMessage()} dismissible color="danger"  isOpen={this.state.errorMessage !== ''}>{this.state.errorMessage}</UncontrolledAlert>
            <Formik
            // enableReinitialize
            // validateOnBlur={true}
            // validateOnChange={true}
                initialValues={defaultValue}
                onSubmit={this.onSubmit}
                validationSchema={this.ValidationSchema}
            >
                {({ errors, touched, values, isValid, setFieldValue, setFieldTouched, handleSubmit }) => (
                    <Fade in={true}>
                        <Form autoComplete="off" onSubmit={handleSubmit}>
                            <FormGroup tag="fieldset">
                                <legend>Verifikasi Data Pribadi</legend>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>NIK<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="nik" id="nik" bsSize="sm"
                                                invalid={errors.nik && touched.nik} />
                                            {errors.nik ? (
                                                <FormFeedback>{errors.nik}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Nama Lengkap<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="fullname" id="fullname" bsSize="sm"
                                                invalid={errors.fullname && touched.fullname} />
                                            {errors.fullname ? (
                                                <FormFeedback>{errors.fullname}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Tempat Lahir<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="pob" id="pob" bsSize="sm"
                                                invalid={errors.pob && touched.pob} />
                                            {errors.pob ? (
                                                <FormFeedback>{errors.pob}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Tanggal Lahir<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="date" name="dob" bsSize="sm"
                                                invalid={errors.dob && touched.dob} />
                                            {errors.dob ? (
                                                <FormFeedback>{errors.dob}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Jenis Kelamin<span className="text-danger">*</span></Label>
                                            <Field className={errors.gender && touched.gender ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                                disabled={this.state.daftar}
                                                component="select" name="gender"
                                                validate={errors.gender && touched.gender}>
                                                <option value="">-- Pilih --</option>
                                                {dataSeed.genders.map((gender, index) =>
                                                    <option value={gender.id} key={index}>{gender.name}</option>
                                                )}
                                            </Field>
                                            {errors.gender && touched.gender ? (
                                                <FormFeedback>{errors.gender}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    {/* <Col md="6">
                                        <FormGroup>
                                            <Label>No Handphone<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="mobilePhone" id="mobilePhone" bsSize="sm"
                                                invalid={errors.mobilePhone && touched.mobilePhone} />
                                            {errors.mobilePhone ? (
                                                <FormFeedback>{errors.mobilePhone}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col> */}
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Email<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="email" id="email" bsSize="sm"
                                                invalid={errors.email && touched.email} />
                                            {errors.email ? (
                                                <FormFeedback>{errors.email}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Nama Ibu Kandung<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="mothersName" id="mothersName" bsSize="sm"
                                                invalid={errors.mothersName && touched.mothersName} />
                                            {errors.mothersName ? (
                                                <FormFeedback>{errors.mothersName}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                               
                                <Row>                                  
                                        <Col md="12" sm="12" xs="12" >
                                            <Alert color="warning">
                                            Apabila Anda mengalami kesulitan dalam melakukan verifikasi data, silakan hubungi customer service kami melalui WhatsApp: <a href='https://wa.me/6285655668378'>0856-5566-8378</a>
                                                </Alert>
                                            <p ></p>
                                            </Col>
                                            </Row>
                                {/* {this.state.daftar === false ?
                                    <Row>
                                        <Col md="2" sm="5" xs="6">
                                            <FormGroup>
                                                <Label>Kode Keamanan<span className="text-danger">*</span></Label><br />
                                                <img src={imageValidation + '?' + this.state.imageHash} alt="" />
                                                <Button onClick={() => this.reloadCaptcha()} type="button" outline color="info" size="sm">Reload Captcha</Button>
                                                <Input type="text" disabled={this.state.daftar} name="code" tag={Field} maxLength="4" bsSize="sm"
                                                    invalid={errors.code && touched.code} />
                                                {errors.code ? (
                                                    <FormFeedback>{errors.code}</FormFeedback>
                                                ) : null}
                                            </FormGroup>
                                        </Col>
                                        <Col md="5">
                                        </Col>
                                    </Row>
                                    : null} */}

                                <Row>
                                    <Col md="3">
                                        <FormGroup>
                                            {this.state.daftar === false ?
                                                this.state.valid ?
                                                    <Button type="button" color="primary" onClick={() => this.pendaftaranClick()} className="btn-block" >Lanjutkan</Button>
                                                    :
                                                    <Button type="submit" disabled={!isValid} color="primary" onClick={this.handleValidateClick} className="btn-block" >Verifikasi</Button>
                                                :
                                                null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <Persist name="dukcapil" />
                        </Form>
                    </Fade>
                )}
            </Formik>
        </React.Fragment>)
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VerifikasiDataPribadi);



// WEBPACK FOOTER //
// ./src/components/PengkinianData/VerifikasiDataPribadi.js